.viewInformation {
	display: flex;
	flex-wrap: wrap;
	gap: 15px 80px;
	padding: 20px calc(var(--jpo-common-base-spacing) * 2);
	border-bottom: 1px solid var(--ds-border, var(--adg3-color-N50));
}

.group {
	display: flex;
	align-items: flex-start;
}

.groupTitle {
	flex: 0 0 auto;
	font-size: 14px;
	color: var(--ds-text-subtlest, var(--adg3-color-N200));
	margin-right: var(--jpo-common-base-spacing);
	white-space: nowrap;
}

.groupContent {
	flex: 1 1 100%;
}

.groupContentItem {
	display: inline-block;
	white-space: nowrap;
	margin-right: var(--jpo-common-base-spacing);
	color: var(--ds-text, var(--adg3-color-N800));
	& strong {
		font-weight: 600;
	}
}
